// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
// Slices
import { fetchFields } from 'slices/field.slice';
import { requestObjectTypes } from 'slices/objectTypes.slice';
import { checkSaveDisabled, fetchTemplate } from 'slices/reportTemplate.slice';
import { useAppDispatch } from 'slices/store';
import { fetchTimeZones } from 'slices/timeZone.slice';
import { DefaultContentLayout } from '@timeedit/ui-components';
import Drawer from './Drawer';
import TableList from './TableList';

const ReportTemplatePage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchTemplate());
    dispatch(fetchFields());
    dispatch(requestObjectTypes());
    dispatch(fetchTimeZones());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardPaddingChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('report_template')}
      subtitle={getText('manage_report_template')}
    >
      <div className="inner-content--wrapper">
        <TableList
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
        <Drawer confirmDiscardPaddingChanges={confirmDiscardPaddingChanges} />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default ReportTemplatePage;
